import { getDownloadManager } from "./downloadManagerSingleton";
import { hydrateDownloads } from "./downloadSlice";
import { startDownloadProgressSync } from "./downloadProgressSync";

let hydrationStarted = false;

export async function hydrateDownloadTransfers({ dispatch, manager } = {}) {
  if (typeof dispatch !== "function") {
    throw new Error("A Redux dispatch function is required to hydrate downloads.");
  }

  const downloadManager = manager || (await getDownloadManager());

  return dispatch(hydrateDownloads({ manager: downloadManager }));
}

export function bootstrapDownloadTransfers({ store, manager } = {}) {
  if (!store || typeof store.dispatch !== "function") {
    throw new Error(
      "A Redux store with dispatch is required to bootstrap download hydration."
    );
  }

  if (hydrationStarted) {
    return null;
  }

  hydrationStarted = true;

  const hydrationPromise = (async () => {
    const downloadManager = manager || (await getDownloadManager());

    await hydrateDownloadTransfers({
      dispatch: store.dispatch,
      manager: downloadManager,
    });

    return startDownloadProgressSync({
      store,
      manager: downloadManager,
    });
  })();

  hydrationPromise.catch((error) => {
    // Hydration must not prevent the app from rendering.
    console.warn(error);
  });

  return hydrationPromise;
}

export function resetDownloadTransferHydrationForTests() {
  hydrationStarted = false;
}
